import React, { useState, useEffect } from 'react'
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import {
  TitleOutline,
  TitleOutlineAll,
  SmallText,
  BigText,
  SectionWrapper,
  DynamicText,
  StatusButton,
} from './Style/style'
import './Style/CalendarComponent.css'
import {
  format,
} from 'date-fns'
import EventPreview from 'modules/Events/Preview/Partials/Drawer/EventPreview'
import Drawer from 'components/Drawer'
import { Col, Row } from 'antd'

const CalendarComponent = ({
  currentWeekStart,
  currentWeekEnd,
  calendarRef,
  eventList,
  handleRegistrationClick,
  handleSingleEventClick
}) => {
  const [initialEvents, setInitialEvents] = useState([])
  const [previewData, setPreviewData] = useState(null)
  const scrollTiming = null
  const [studentDrawerOpen, setStudentDrawerOpen] = useState(false)
  const categoryStyles = {
    OTHERS: {
      borderColor: '#001B48',
      backgroundColor: 'rgba(0, 27, 72, 0.2)',
      textColor: 'White',
    },
    PRE_PLACEMENT_TALK: {
      borderColor: '#97CADB',
      backgroundColor: 'rgba(151, 202, 219, 0.2)',
      textColor: 'Black',
    },
    SEMINAR: {
      borderColor: '#B5A3F7',
      backgroundColor: 'rgba(181, 163, 247, 0.2)',
      textColor: 'Black',
    },
    WEBINAR: {
      borderColor: '#E1A7BA',
      backgroundColor: 'rgba(225, 167, 186, 0.2)',
      textColor: 'Black',
    },
    LECTURE: {
      borderColor: '#8D6AA0',
      backgroundColor: 'rgba(141, 106, 160, 0.2)',
      textColor: 'White',
    },
    CONFERENCE: {
      borderColor: '#F29F05',
      backgroundColor: 'rgba(242, 159, 5, 0.2)',
      textColor: 'Black',
    },
    PANEL_DISCUSSION: {
      borderColor: '#F25C05',
      backgroundColor: 'rgba(242, 92, 5, 0.2)',
      textColor: 'Black',
    },
    HACKATHON: {
      borderColor: '#31AAB5',
      backgroundColor: 'rgba(49, 170, 181, 0.2)',
      textColor: 'Black',
    },
    WORKSHOP: {
      borderColor: '#72B06F',
      backgroundColor: 'rgba(114, 176, 111, 0.2)',
      textColor: 'Black',
    },
    CAMPAIGN: {
      borderColor: '#4C1D91',
      backgroundColor: 'rgba(76, 29, 145, 0.2)',
      textColor: 'White',
    },
    SPORTS_EVENT: {
      borderColor: '#13593F',
      backgroundColor: 'rgba(19, 89, 63, 0.2)',
      textColor: 'White',
    },
    ACTIVITY_EVENT: {
      borderColor: '#02457A',
      backgroundColor: 'rgba(2, 69, 122, 0.2)',
      textColor: 'White',
    },
    EXHIBITION: {
      borderColor: '#595F33',
      backgroundColor: 'rgba(89, 95, 51, 0.2)',
      textColor: 'White',
    },
  }
  const typeLabels = {
    OTHERS: 'Others',
    PRE_PLACEMENT_TALK: 'Pre Placement Talk',
    SEMINAR: 'Seminar',
    WEBINAR: 'Webinar',
    LECTURE: 'Lecture',
    CONFERENCE: 'Conference',
    PANEL_DISCUSSION: 'Panel Discussion',
    HACKATHON: 'Hackathon',
    WORKSHOP: 'Workshop',
    CAMPAIGN: 'Campaign',
    SPORTS_EVENT: 'Sports Event',
    ACTIVITY_EVENT: 'Activity Event',
    EXHIBITION: 'Exhibition',
  }
  const categoryBasedStyle = status => {
    switch (status) {
      case 'EXHIBITION':
        return {
          color: '#ffffff',
          bgColor: 'rgb(89 95 51 / 20%)',
          borderColor: '#595F33',
          status: 'Exhibition',
        }
      case 'ACTIVITY_EVENT':
        return {
          color: '#ffffff',
          bgColor: 'rgba(2, 69, 122, 0.2)',
          borderColor: '#02457A',
          status: 'Activity/Event',
        }
      case 'SPORTS_EVENT':
        return {
          color: '#ffffff',
          bgColor: 'rgb(19 89 63 / 20%)',
          borderColor: '#13593F',
          status: 'Sports/Event',
        }
      case 'CAMPAIGN':
        return {
          color: '#ffffff',
          bgColor: 'rgba(223, 147, 255, 0.25)',
          borderColor: '#4C1D91',
          status: 'Campaign',
        }
      case 'WORKSHOP':
        return {
          color: '#000000',
          bgColor: 'rgb(114 176 111 / 20%)',
          borderColor: '#72B06F',
          status: 'Workshop',
        }
      case 'HACKATHON':
        return {
          color: '#000000',
          bgColor: 'rgb(49 170 181 / 20%)',
          borderColor: '#31AAB5',
          status: 'Hackathon',
        }
      case 'PANEL_DISCUSSION':
        return {
          color: '#ffffff',
          bgColor: 'rgb(242 92 5 / 20%)',
          borderColor: '#F25C05',
          status: 'Panel Discussion',
        }
      case 'CONFERENCE':
        return {
          color: '#000000',
          bgColor: 'rgb(242 159 5 / 25%)',
          borderColor: '#F29F05',
          status: 'Conference',
        }
      case 'LECTURE':
        return {
          status: 'Lecture',
          bgColor: 'rgb(141 106 160 / 20%)',
          borderColor: '#8D6AA0',
          color: '#000000',
        }
      case 'WEBINAR':
        return {
          status: 'Webinar',
          bgColor: 'rgba(255, 182, 193, 0.25)',
          borderColor: '#E1A7BA',
          color: '#000000',
        }
      case 'SEMINAR':
        return {
          status: 'Seminar',
          bgColor: 'rgba(181, 163, 247, 0.25)',
          borderColor: '#B5A3F7',
          color: '#000000',
        }
      case 'PRE_PLACEMENT_TALK':
        return {
          status: 'Pre Placement Talk',
          bgColor: 'rgb(151 202 219 / 20%)',
          borderColor: '#97CADB',
          color: '#000000',
        }
      case 'OTHERS':
        return {
          status: 'Others',
          borderColor: 'rgba(0, 27, 72, 1)',
          bgColor: 'rgba(0, 27, 72, 0.2)',
          color: '#ffffff',
        }
      default:
        return {
          color: '#000000',
          bgColor: '#F3F3F3',
          borderColor: '#00000045',
          status: status,
        }
    }
  }
  useEffect(() => {
    const splitMultiDayEvent = event => {
      const start =
        event?.isRegister && event?.studentEventMapping?.length === 0
          ? new Date(event?.registerStartDate)
          : new Date(event.startDate)
      const end =
        event?.isRegister && event?.studentEventMapping?.length === 0
          ? new Date(event?.registerEndDate)
          : new Date(event.endDate)
          const startDateOnly = new Date(start.toISOString().split('T')[0]);
          const endDateOnly = new Date(end.toISOString().split('T')[0]);
          const days = Math.ceil((endDateOnly - startDateOnly) / (1000 * 60 * 60 * 24)) + 1;
          const eventDays = [];
        
          for (let i = 0; i < days; i++) {
            const currentDate = new Date(startDateOnly.getTime() + i * (1000 * 60 * 60 * 24));
            const eventDay = {
              ...event,
              startDate: currentDate.toISOString(),
              endDate: currentDate.toISOString(),
            };
        
            if (i === 0) {
              eventDay.startDate = start.toISOString();
            }
            if (i === days - 1) {
              eventDay.endDate = end.toISOString();
            }
        
            eventDays.push(eventDay);
          }
      
          return eventDays;
    }

    let dataList = eventList?.flatMap(event => {
      const regex = /T(\d{2}):(\d{2}):(\d{2}).(\d{3})Z/

      const allDay =
        event?.isRegister && event?.studentEventMapping?.length === 0
          ? true
          : event.allDayEvent
      const start =
        event?.isRegister && event?.studentEventMapping?.length === 0
          ? event?.registerStartDate?.split('T')[0]
          : event?.startDate?.split('T')[0]
      const end =
        event?.isRegister && event?.studentEventMapping?.length === 0
          ? event?.registerEndDate?.split('T')[0]
          : event?.endDate?.split('T')[0]
      const categoryStyle = categoryStyles[event.category] || {}
      const textColor = allDay
        ? categoryStyle.borderColor
        : categoryStyle.textColor

      if (start !== end) {
        return splitMultiDayEvent(event).map(dayEvent => ({
          start: allDay
            ? dayEvent?.startDate?.split('T')[0]
            : dayEvent?.startDate?.replace(
                regex,
                `T${event?.startTime + ':00'}`
              ),
          end: allDay
            ? dayEvent?.endDate?.split('T')[0]
            : dayEvent?.endDate?.replace(regex, `T${event?.endTime + ':00'}`),
          allDay: allDay,
          className: event?.className,
          category: typeLabels[event?.category],
          id: event?.id,
          title: event?.title,
          borderColor: allDay ? 'transparent' : categoryStyle.borderColor,
          backgroundColor: allDay ? 'none' : categoryStyle.backgroundColor,
          textColor: textColor,
          isRegister: event?.isRegister && event?.studentEventMapping?.length === 0,
          fullData: event,
          margin: '10px'
        }))
      } else {
        return {
          start: allDay
            ? start
            : event?.startDate?.replace(regex, `T${event?.startTime + ':00'}`),
          end: allDay
            ? end
            : event?.endDate?.replace(regex, `T${event?.endTime + ':00'}`),
          allDay: allDay,
          className: event?.className,
          category: typeLabels[event?.category],
          id: event?.id,
          title: event?.title,
          borderColor: allDay ? 'transparent' : categoryStyle.borderColor,
          backgroundColor: allDay ? 'none' : categoryStyle.backgroundColor,
          textColor: textColor,
          isRegister: event?.isRegister && event?.studentEventMapping?.length === 0,
          fullData: event,
          margin: '10px'

        }
      }
    })

if (Array.isArray(dataList) && dataList.length > 0) {
  setInitialEvents(prev =>
    prev?.length > dataList.length ? prev : dataList
  )
}  }, [eventList])


  useEffect(() => {
    const timeAxisHeader = document.querySelector('.fc-timegrid-axis')
    if (timeAxisHeader && !timeAxisHeader.querySelector('.fc-timegrid-axis')) {
      const timeAxisTitle = document.createElement('div')
      timeAxisTitle.className = 'fc-timegrid-axis'
      timeAxisTitle.innerText = 'Time'
      timeAxisHeader.insertBefore(timeAxisTitle, timeAxisHeader.firstChild)
    }
  }, [])
  const [isDrawerVisible, setIsDrawerVisible] = useState(false)
  const handleEventClick = async clickInfo => {
    handleSingleEventClick(clickInfo?.event?.extendedProps?.fullData)
  }
  const handleDrawerClose = () => {
    setPreviewData(null)
    setIsDrawerVisible(false) // Set drawer visibility to false on close
  }

  const renderEventContent = eventInfo => {
    const { title, extendedProps } = eventInfo.event
    const { category } = extendedProps

    if (eventInfo.event.allDay) {
      return (
        <>
          <TitleOutlineAll textColor={eventInfo.event.textColor}>
            {title?.toLowerCase()} {extendedProps?.isRegister && '(Register)'}
          </TitleOutlineAll>
          {/* <SmallText>{category}</SmallText> */}
        </>
      )
    } else {
      return (
        <>
          <TitleOutline
            textColor={eventInfo.event.textColor}
            backgroundColor={eventInfo.event.borderColor}
          >
            {title?.toLowerCase()}
          </TitleOutline>
          <SmallText>({category})</SmallText>
          <BigText>
            {format(new Date(eventInfo.event.start), 'p')} -{' '}
            {format(new Date(eventInfo.event.end), 'p')}
          </BigText>
        </>
      )
    }
  }

  const handleStudentDrawerClick = () => {
    setStudentDrawerOpen(true)
  }
  const registrationContent = () => {
    return (
        <div
          style={{
            padding: '2rem',
            // display: 'flex',
            height: '100%',
            // flexDirection: 'column',
            // alignItems: 'flex-end',
          }}
        >
          <Row style={{ gap: '2rem' }}>
            <Col span={24}>
              <DynamicText>Name</DynamicText>
              <DynamicText fontWeight={700}>Ananthi</DynamicText>
            </Col>
            <Col span={24}>
              <DynamicText>Contact details</DynamicText>
              <DynamicText fontWeight={700}>Ananthi</DynamicText>
            </Col>
            <Col span={24}>
              <DynamicText>Degree & Department</DynamicText>
              <DynamicText fontWeight={700}>Ananthi</DynamicText>
            </Col>
          </Row>
          <Row>
            <Col>* These details will be sent for registration</Col>
          </Row>
        </div>
    )
  }
  const registrationFooter = () => {
    return (
      <Row style={{ justifyContent: 'flex-end', gap: '2rem' }}>
        <StatusButton
          text={'Cancel'}
          status={'cancel'}
          // onClick={handleClick}
        />
        <StatusButton
          text={'Register'}
          status={'register'}
          // onClick={handleClick}
          removeLeft={true}
        />
      </Row>
    )
  }
  return (
    <>
      <SectionWrapper>
        <FullCalendar
          ref={calendarRef}
          slotEventOverlap={false}
          eventOverlap={false}
          plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
          headerToolbar={false}
          allDayText="All day"
          slotLabelContent={arg => {
            const date = new Date(arg.date)
            const hour = date.getHours()
            const ampm = hour >= 12 ? 'PM' : 'AM'
            const formattedHour = hour % 12 || 12
            return `${formattedHour} ${ampm}`
          }}
          initialView="timeGridWeek"
          slotDuration="01:00:00"
          nowIndicator={true}
          editable={false}
          selectable={true}
          selectMirror={false}
          dayMaxEvents={false}
          weekends={true}
          events={initialEvents}
          eventContent={renderEventContent}
          eventClick={handleEventClick}
          dayHeaderFormat={{ weekday: 'short', day: '2-digit' }}
          visibleRange={
  currentWeekStart && currentWeekEnd
    ? { start: currentWeekStart, end: currentWeekEnd }
    : undefined
}
          scrollTime={scrollTiming}
        />
      </SectionWrapper>
      {isDrawerVisible && (
        // <PreviewDrawer open={isDrawerVisible} onClose={handleDrawerClose} eventDetails={previewData} />

        <EventPreview
          open={isDrawerVisible}
          header={true}
          onClose={handleDrawerClose}
          categoryBasedObj={categoryBasedStyle(previewData?.category)}
          data={previewData || []}
          handleClick={handleStudentDrawerClick}
          handleRegistrationClick={handleRegistrationClick}
        />
      )}
      <Drawer
        width="600px"
        placement="right"
        padding="-30px"
        closable
        onClose={handleDrawerClose}
        visible={studentDrawerOpen}
        content={registrationContent()}
        footer={registrationFooter()}
      />
    </>
  )
}

export default CalendarComponent